import { render, staticRenderFns } from "./ParametersTable.vue?vue&type=template&id=2cdb4cc2&scoped=true&"
import script from "./ParametersTable.vue?vue&type=script&lang=js&"
export * from "./ParametersTable.vue?vue&type=script&lang=js&"
import style0 from "./ParametersTable.vue?vue&type=style&index=0&id=2cdb4cc2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdb4cc2",
  null
  
)

export default component.exports